function clear(args) {
  return "clear";
}

export { clear };
